export const PROJECT = {
	APP: {
		BASENAME: process.env.REACT_APP_API_BASE_URL || '/',
	},
};
